// extracted by mini-css-extract-plugin
export default {"root_image_inner":"scheduleUpdationForm_root_image_inner__PS5DM","FormTabs_root":"scheduleUpdationForm_FormTabs_root__VLbt2"};